module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity/product-images/frat-product-1-50d13528eb110b2b921b6489a1992f14.jpg";